import React from 'react';
import PropTypes from 'prop-types';
import { DashboardModal } from '../components/DashboardModal';
import { fetchResource } from 'api-provider/actions'
import { apiRequestPromise } from 'api-provider';
import __ from 'utils/i18n';
import get from 'lodash/get';
import { connect } from 'react-redux';
import { getConfig } from 'config';
import { Button, Col, Row } from 'reactstrap';
import ImageQR from 'assets/qrestatico.svg';
import Loader from 'components/Loader';
import ErrorMessage from 'components/flashMessages/ErrorMessage';
import { downloadBase64Pdf } from 'utils/downloadBase64Pdf';

class StaticQRCodeModal extends React.Component {
  constructor({ token }) {
    super();

    this.state = {
      isLoading: false,
      downloadFailed: false,
    };

    this.useV4 = getConfig('customConfig.staticQR.useV4', false);

    this.resources = {
      download: () => {
        return {
          endpoint: "account/qr",
          method: "POST",
          headers: { "X-Authentication-Token": token },
        };
      },
      downloadV4: (pointOfSaleUUID) => {
        return {
          endpoint: `api/v1/qr-payments/${pointOfSaleUUID}?includePdf=true`,
          method: "POST",
          headers: { "X-Authentication-Token": token },
        };
      },
    };
  }

  fetchQRData = () => {
    if (this.useV4) {
      this.fetchQRDataV4();
      return;
    }

    this.setState({ isLoading: true, downloadFailed: false });

    fetchResource(this.resources.download)
      .onSuccess((data) => {
        this.download(data.pdfUrl);
        this.setState({ isLoading: false });
      })
      .onFailure(() => {
        this.setState({
          downloadFailed: true,
          isLoading: false,
        });
      });
  };

  fetchQRDataV4 = async () => {
    const { pointOfSaleUUID } = this.props;

    if (!pointOfSaleUUID) {
      this.setState({ downloadFailed: true, isLoading: false });
      return;
    }

    this.setState({ isLoading: true, downloadFailed: false });

    try {
      const resource = this.resources.downloadV4(pointOfSaleUUID);
      const response = await apiRequestPromise({
        url: resource.endpoint,
        method: resource.method,
        headers: resource.headers,
      });

      const pdfBase64 =
        response?.data?.pdf_base64 || response?.data?.data?.pdf_base64;

      if (!pdfBase64) {
        this.setState({ downloadFailed: true, isLoading: false });
        return;
      }

      downloadBase64Pdf(pdfBase64, 'QR.pdf');
      this.setState({ isLoading: false });
    } catch (error) {
      console.error('[StaticQRCodeModal] Error al obtener el QR V4:', error);
      this.setState({ downloadFailed: true, isLoading: false });
    }
  };

  download = (url) => {
    let win = window.open(url, "_blank");
    win.focus();
  };

  render() {
    const { isOpen, toggle } = this.props;

    return (
      <DashboardModal
        showModal={isOpen}
        hideModal={() => toggle("false")}
        headerText={__("dashboard.components.modal.qrCode.headerText")}
        cancelText={__("actions.close")}
        modalClass="static-qr-code-modal"
      >
        <Row className="box-info">
          <Col>
            <Row>
              <Col lg="2">
                <img src={ImageQR} alt=""/>
              </Col>
              <Col lg="7">
                <p style={{ color: "#333333" }}>
                  <strong>
                    {__("dashboard.components.modal.qrCode.downloadAndPrint")}
                  </strong>
                </p>
                <p
                  style={{ color: "#999999" }}
                  dangerouslySetInnerHTML={{
                    __html: __(
                      "dashboard.components.modal.qrCode.putOnAVisibleLocation"
                    ),
                  }}
                ></p>
              </Col>
              <Col lg="3">
                {!this.state.isLoading ? (
                  <Button
                    color="link"
                    type="button"
                    onClick={() => this.fetchQRData()}
                  >
                    <strong>{__("actions.download")}</strong>
                  </Button>
                ) : (
                  <Loader isLoading={true} />
                )}
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col>
            {this.state.downloadFailed && (
              <ErrorMessage>
                {__("dashboard.components.modal.qrCode.downloadError")}
              </ErrorMessage>
            )}
          </Col>
        </Row>
      </DashboardModal>
    );
  }
}

StaticQRCodeModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  toggle: PropTypes.func.isRequired,
  pointOfSaleUUID: PropTypes.string,
};

const mapStateToProps = (state) => ({
  token: get(state, 'api.token'),
  pointOfSaleUUID: get(state, 'login.user.pointOfSaleUUID'),
});

export default connect(mapStateToProps)(StaticQRCodeModal);
